import { observer } from 'mobx-react';
import * as React from 'react';
import { DraggableProvided } from '@hello-pangea/dnd';
import { T } from '../../../../../../Translations';
import StarIcon from '../../../../../Cutesies/StarIcon';
import LearningCollectionEditStore from '../../../Edit/Store';
import { LearningDesignSection, sectionContext } from '../../../Types';
import CustomizeExperiences from '../CustomizeExperiences';
import CustomizeLearningDesignDetails from '../CustomizeLearningDesignDetails';
import ExperienceCatalogButton from '../ExperienceCatalogButton';
import { LearningCollectionEditFormResource } from '../../../Edit/Store/Types';

interface Props {
  store: LearningCollectionEditStore;
  section: LearningDesignSection;
  provided: DraggableProvided;
  learningCollectionEditFormResource: LearningCollectionEditFormResource;
}

const BrowseAllExperiences: React.FC<Props> = ({
  store,
  section,
  provided,
  learningCollectionEditFormResource,
}) => {
  return (
    <CustomizeExperiences
      key={section.resource.payload.id}
      store={store}
      openByDefault
      titleIcon={
        <div className="flex gap-4">
          <StarIcon />
        </div>
      }
      titleJSX={<CustomizeLearningDesignDetails store={store} section={section} />}
      countDisplay={
        <T
          kind="Includes <span>{{count}} program(s)</span>"
          span={(content) => <span className="font-semibold">{content}</span>}
          count={store.experienceStores(sectionContext(section)).length}
        />
      }
      customizationActions={
        <ExperienceCatalogButton
          store={store}
          section={section}
          learningCollectionEditFormResource={learningCollectionEditFormResource}
        />
      }
      section={section}
      provided={provided}
    />
  );
};

export default observer(BrowseAllExperiences);
